import { useQueryStringState } from './useQueryStringState';

interface IUseTablePagination {
  page: number;
  setPage: (page: number) => void;
  rowsPerPage: number;
  setRowsPerPage: (rowsPerPage: number) => void;
}

const useTablePagination = (defaultPage = 1, defaultRowsPerPage = 20): IUseTablePagination => {
  const [page, setPage] = useQueryStringState<number>('page', defaultPage);
  const [rowsPerPage, setRowsPerPage] = useQueryStringState<number>('rowsPerPage', defaultRowsPerPage);

  return { page, setPage, rowsPerPage, setRowsPerPage };
};

export default useTablePagination;
